
import { PostAPIWithoutRequestAndKeyData,PostAPI } from "../helper/apiHelper";

export const SelectPropertyType = async () => {
  return PostAPIWithoutRequestAndKeyData('PropertyTypeMaster/SelectPropertyType');
};

export const SelectRoomType = async () => {
  return PostAPIWithoutRequestAndKeyData('PGPropertyDetails/SelectRooms');
};

export const SelectTenantType = async () => {
  return PostAPIWithoutRequestAndKeyData('PGPropertyDetails/SelectTenants');
};

export const SelectBusinessType = async () => {
  return PostAPIWithoutRequestAndKeyData('BusinessType/SelectBusinessType');
};

export const SelectWashroomType = async () => {
  return PostAPIWithoutRequestAndKeyData('WashroomType/SelectWashroomType');
};

export const SelectRentType = async () => {
  return PostAPIWithoutRequestAndKeyData('InfraAndFacilities/SelectRentType');
};

export const SelectPowerBackupType = async () => {
  return PostAPIWithoutRequestAndKeyData('InfraAndFacilities/SelectPowerBackup');
};

export const SelectParkingType = async () => {
  return PostAPIWithoutRequestAndKeyData('InfraAndFacilities/SelectParkingType');
};

export const SelectLiftFacility = async () => {
  return PostAPIWithoutRequestAndKeyData('InfraAndFacilities/SelectLiftFacility');
};

export const SelectAirConditioning = async () => {
  return PostAPIWithoutRequestAndKeyData('InfraAndFacilities/SelectAirConditioning');
};
export const SelectInternet = async () => {
  return PostAPIWithoutRequestAndKeyData('InfraAndFacilities/SelectInternet');
};

export const SelectSecuritySystem = async () => {
  return PostAPIWithoutRequestAndKeyData('InfraAndFacilities/SelectSecuritySystem');
};

export const GenerateOTP = async (request: any) => {
  return PostAPI(request, 'Enquiry/GenerateOTP');
};
export const VerifyOTP = async (request: any) => {
  return PostAPI(request, 'Enquiry/VerifyOTP');
};

export const GoogleLogin = async (request: any) => {
  return PostAPI(request, 'Credential/GoogleLogin');
};

export const GenerateSignUpOTP = async (request: any) => {
  return PostAPI(request, 'Enquiry/GenerateSignUpOTP');
};
export const VerifySignUpOTP = async (request: any) => {
  return PostAPI(request, 'Enquiry/VerifySignUpOTP');
};

export const SelectCities = async () => {
  return PostAPIWithoutRequestAndKeyData('SearchProperty/GetDistinctCities');
};

export const SearchProperty = async (request: any) => {
  return PostAPI(request, 'SearchProperty/SearchProperties');
};